/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Tokens
 */
export interface Tokens {
  /**
   *
   */
  access?: string;
  /**
   *
   */
  refresh?: string;
}

/**
 * Check if a given object implements the Tokens interface.
 */
export function instanceOfTokens(value: object): value is Tokens {
  return true;
}

export function TokensFromJSON(json: any): Tokens {
  return TokensFromJSONTyped(json, false);
}

export function TokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tokens {
  if (json == null) {
    return json;
  }
  return {
    access: json["access"] == null ? undefined : json["access"],
    refresh: json["refresh"] == null ? undefined : json["refresh"],
  };
}

export function TokensToJSON(json: any): Tokens {
  return TokensToJSONTyped(json, false);
}

export function TokensToJSONTyped(
  value?: Tokens | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    access: value["access"],
    refresh: value["refresh"],
  };
}
